import React, { useContext } from "react";
import { Sparkles } from "lucide-react";
import { AuthContext } from "../context/AuthContext";
import { ROLE_LABEL, can } from "../access";

/**
 * Renders a polished "Coming Soon" surface for portal pages whose role-specific
 * variants are not built yet. Reads the user's role + access level for the
 * given module and reflects that on the page so it never feels like a 404.
 */
export default function RoleScopedPlaceholder({ title, moduleKey, icon: Icon = Sparkles }) {
  const { user } = useContext(AuthContext);
  const role = user?.role || "";
  const level = can(role, moduleKey);

  const LEVEL_HINT = {
    full: "You'll be able to create, edit and delete records here.",
    view: "You'll have read-only access scoped to your data.",
    own:  "You'll be able to see records that belong to you.",
  };

  return (
    <div className="page-wrap">
      <div className="page-header">
        <h1 className="page-title">{title}</h1>
        <p className="page-sub">
          Your access level: <strong>{level === "full" ? "Full" : level === "view" ? "View" : level === "own" ? "Own only" : "None"}</strong>
          {" · "}{ROLE_LABEL[role] || role}
        </p>
      </div>
      <div className="empty-card" data-testid={`role-placeholder-${moduleKey}`}>
        <div className="coming-soon-icon-wrap">
          <Icon size={40} color="#43E0FF" />
        </div>
        <p className="coming-soon-title">Coming Soon</p>
        <p className="coming-soon-sub">
          {LEVEL_HINT[level] || "This section will be enabled for your role shortly."}
        </p>
      </div>
    </div>
  );
}
